// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__IDOac","signatureButtonsRight":"ModalSign_signatureButtonsRight__2gIyl"};